import React, { useEffect, useState } from "react";
import { Card, Button, ButtonList, Wrapper, Respects, Header } from "./styles";
import Reports from "../../views/Reports";
import ReportsGroup from "../../views/ReportsGroup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExchangeAlt,
  faHome,
  faHospitalUser,
  faMicroscope,
  faUserNurse,
  faUserPlus,
} from "@fortawesome/free-solid-svg-icons";
import Slide from "../../components/Slide";
import api from "../../services/client/api";
import cookie from "../../services/cookie/index";
import { deleteCookies } from "../../utils/functions";
import { useHistory } from "react-router-dom";

export default function Home() {
  const [tab, setTab] = useState("reports");
  const [first, setFirst] = useState(true);
  const [Name, setName] = useState("");
  const CodTitulo = cookie().get("CodTitulo");

  const getTitle = (cod) => {
    switch (cod) {
      case "1":
        return "Dr.";
      case "2":
        return "Dra.";
      case "3":
        return "Enfº";
      case "4":
        return "Enfª";
      default:
        return "";
    }
  };
  const history = useHistory();
  const [groupsThatIBelong, setGroupsThatIBelong] = useState([]);
  const formatName = (name = "") => {
    const lowerWords = ["da", "de", "do", "das", "dos", "e"];

    return name
      .toLowerCase()
      .split(" ")
      .filter(Boolean)
      .map((word, index) => {
        if (index > 0 && lowerWords.includes(word)) {
          return word;
        }

        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(" ");
  };

  const requirePermission = cookie().get("requirePermission") === "true";
  const usePermissionCard =
    requirePermission && cookie().get("DocList") !== "false";
  const [permissionGranted, setPermissionGranted] =
    useState(!requirePermission);

  const changeListing = () => {
    const current = cookie().get("DocList") === "true";

    cookie().set("DocList", (!current).toString());

    window.location.reload();
  };
  useEffect(() => {
    if (first) {
      getGroupsThatIBelong();
      getName();
    }
  }, [first]);

  const getName = async () => {
    const name = await cookie().get("name");
    setName(formatName(name));
  };

  const getGroupsThatIBelong = async () => {
    const token = await cookie().get("token");
    const response = await api().group().getByUser(token);

    if (response.status === 401) {
      await deleteCookies();
      return history.push({ pathname: "/login" });
    }

    setFirst(false);

    if (response.status === 200) {
      setGroupsThatIBelong(response.output);
      return;
    }
    setGroupsThatIBelong([]);
  };

  return (
    <div>
      <Slide
        title={
          <>
            <FontAwesomeIcon icon={faHome} /> Home
          </>
        }
      />

      <Header>
        <Respects>
          Olá, <b>{`${getTitle(CodTitulo)} ${Name}`.trim()}</b>!
        </Respects>
        {requirePermission && (
          <ButtonList
            style={{ cursor: "pointer", margin: 0 }}
            onClick={changeListing}
          >
            {cookie().get("DocList") === "true" ? (
              <>
                Listar Exames <FontAwesomeIcon icon={faMicroscope} />
              </>
            ) : (
              <>
                Buscar paciente <FontAwesomeIcon icon={faHospitalUser} />
              </>
            )}
          </ButtonList>
        )}
      </Header>

      <Card>
        {!usePermissionCard ? (
          <h1>
            <FontAwesomeIcon icon={faMicroscope} /> Busca de exames
          </h1>
        ) : (
          <>
            <h1>
              <FontAwesomeIcon icon={faHospitalUser} /> Busca de paciente
            </h1>
          </>
        )}

        {groupsThatIBelong.length > 0 && (
          <Wrapper>
            <Button
              onClick={() => setTab("reports")}
              active={tab === "reports" && true}
            >
              Laudos Gerais
            </Button>
            <Button
              onClick={() => setTab("reportsGroup")}
              active={tab === "reportsGroup" && true}
            >
              Laudos por grupo
            </Button>
          </Wrapper>
        )}

        {tab === "reports" ? (
          <Reports />
        ) : (
          <ReportsGroup groupsThatIBelong={groupsThatIBelong} />
        )}
      </Card>
    </div>
  );
}
